import { postLeadForm } from 'pages/api/api';

/**
 * @param {{
 *  brand: string,
 *  year: string,
 *  name: string,
 *  lastname: string,
 *  email: string
 * }} payload Lead Form submitted information.
 */
export default function leadFormSubmissionService ({
    brand,
    email,
    lastname,
    name,
    year,
    culture
}) {
    const payload = {
        first_name: name,
        last_name: lastname,
        email: email,
        culture: culture
    };

    return postLeadForm(payload);
}
